"use client";
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function RootPage() {
  const router = useRouter();
  
  useEffect(() => {
    // マウント直後に履歴を残さずログイン画面へ遷移
    router.replace('/login');
  }, [router]);

  return null; // 画面には何も描画しない
}
